import React, { useEffect, useState } from 'react'
import { satisfaccion_2_catalog } from './satisfaccion_2.catalog'
import { Button, Form, Input, message, Radio } from 'antd'
import { CardHeader, InfoCard, NameLabel, onFinishFailed } from '../utils'
import { checkEncuesta, EncuestaLoading, ThanksMessage } from '../utils'
import { sendDataBody } from '../../resources'

export default function Satisfaccion2Encuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default' }) {
    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'satisfaccion_2', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)
    }


    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            tipo: 'satisfaccion_2',
            satisfaccion_2: values,
            uuid: token,
            visita: visita,
            sesion: session,
            protocolo: protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };



    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage />

    return (
        <div className='parentContainer'>
            <CardHeader title="Encuesta de satisfacción">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>
                <p>Agradecemos sinceramente que dedique unos minutos a compartir su experiencia. Su opinión es fundamental para que podamos mejorar nuestros servicios en CIDERALT. La encuesta es anónima y sus respuestas se utilizarán exclusivamente para fines de mejora continua.</p>

                <Form
                    layout='vertical'
                    name="satisfaccion2_enc"
                    // labelCol={{ span: 24 }}
                    // wrapperCol={{ span: 24 }}
                    initialValues={[]}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >


                    {
                        satisfaccion_2_catalog.map((pregunta, index) => (
                            <div key={index}>
                                {pregunta.tipo === 'radioButton' && (
                                    <Form.Item
                                        label={pregunta.label}
                                        name={index}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Radio.Group onChange={onChange} >
                                            <Radio value={0}>Totalmente en desacuerdo</Radio>
                                            <Radio value={1}>En desacuerdo</Radio>
                                            <Radio value={2}>Neutral</Radio>
                                            <Radio value={3}>De acuerdo</Radio>
                                            <Radio value={4}>Totalmente de acuerdo</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                )}
                                {pregunta.tipo === 'texto' && (
                                    <Form.Item
                                        label={pregunta.label}
                                        name={index}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                )}
                                {pregunta.tipo === 'seleccion' && (
                                    <Form.Item
                                        label={pregunta.label}
                                        name={index}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your username!',
                                            },
                                        ]}
                                    >
                                        <Radio.Group onChange={onChange} >
                                            <Radio value={"Si"}>Si</Radio>
                                            <Radio value={"No"}>No</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                )}
                            </div>
                        ))
                    }


                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button form='satisfaccion2_enc' type="primary" htmlType="submit">
                            Enviar respuestas
                        </Button>
                    </Form.Item>

                </Form>




            </div>
        </div>
    )
}